import { createStorageAtomFactory } from '@exodus/atoms'

const createLocalSeedBackupMaxAgeAtom = ({ storage, config }) => {
  return createStorageAtomFactory({ storage })({
    key: 'localSeedBackupMaxAge',
    defaultValue: config.defaultMaxAge,
  })
}

export default createLocalSeedBackupMaxAgeAtom
